import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startAlerta } from "./ui/alertas";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { fileUploadCertificado } from "../helpers/fileUpload";
import { TAMANO_IMAGENES } from "../utils/constants";
import { fileSize } from "../helpers/filesFunctions";
import CertificadosService from "../services/CertificadosService"

export const certificadosTraerStart = () => ({
  type: types.certificadosTraerCargadaStart,
});
export const certificadosLimpiar = () => ({
  type: types.certificadosLimpiarLista,
});
export const certificadosTraerError = (error) => ({
  type: types.certificadosTraerCargadaError,
  payload: error,
});
export const certificadosTraerSuccess = (payload) => {
  return {
    type: types.certificadosTraerCargadaSuccess,
    payload: payload,
  };
};
export const certificadosCompletoPreAfi = (payload) => {
  return {
    type: types.certificadosCompletoPreAfi,
    payload: payload,
  };
};

export const startUploading = (file, idCert, esPreAfiliacion) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    if (file.size <= TAMANO_IMAGENES.CERTIFICADOS) {
      const nuevaImgCertif = await fileUploadCertificado(file, idCert, esPreAfiliacion);
      const imgCertifPreparada = {};
      imgCertifPreparada.idItem = nuevaImgCertif.IdItem;
      imgCertifPreparada.idCertificado = nuevaImgCertif.IdCertificado;
      imgCertifPreparada.nombreDocumento = nuevaImgCertif.NombreDocumento;
      imgCertifPreparada.url = nuevaImgCertif.Url;
      imgCertifPreparada.fechaCarga = nuevaImgCertif.FechaCarga;
      imgCertifPreparada.idUsuarioAlta = nuevaImgCertif.IdUsuarioAlta;
      imgCertifPreparada.idUsuarioBaja = nuevaImgCertif.IdUsuarioBaja;
      imgCertifPreparada.fechaBaja = nuevaImgCertif.FechaBaja;
      dispatch(imageCertificadoSaved(imgCertifPreparada));
      dispatch(finishSpinner());
      dispatch(startAlerta(`Imagen Certificado Guardada`,'success','Comando Exitoso'));
    }else{
      dispatch(startAlerta(`El archivo no puede ser mayor a: ${fileSize(TAMANO_IMAGENES.CERTIFICADOS)} y el mismo tiene: ${fileSize(file.size)}`,'info'));
    }
    
  };
};

const imageCertificadoSaved = (imagen) => ({
  type: types.certificadosImageUploaded,
  payload: imagen,
});
const imageCertificadoDelete = (certificado) => ({
  type: types.certificadosImageDelete,
  payload: certificado,
});
export const certificadosInsertError = (error) => ({
  type: types.certificadosInsertError,
  payload: error,
});

const certificadoInsertSuccess = (payload) => {
  return {
    type: types.certificadosInsertSuccess,
    payload: payload,
  };
};
const certificadoUpdated = (cert) => {
  return {
    type: types.certificadosUpdated,
    payload: cert,
  };
};
const certificadoDelete = (idCertificado) => {
  return {
    type: types.certificadosDelete,
    payload: idCertificado,
  };
};
export const certificadoStartUpdate = ({ formValues }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      delete formValues.imagenCertificado;
      delete formValues.fechaCarga;
      delete formValues.fechaBaja;
      delete formValues.fechaModificacion;
      const response = await fetchConToken(
        `CertificadosAfiliados/${formValues.idItem}`,
        formValues,
        "PUT"
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(
            startAlerta(
              `Documentacion Actualizada correctamente`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(certificadoUpdated(formValues));
        } else {
          dispatch(startAlerta(response, "error", "Error"));
          console.log(response);
          throw new Error(response);
        }
      } else {
        console.log(response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, "error", "Error"));
      console.log("error en update certificado afiliado", error);
    }
  };
};
export const certificadoDiscaStartUpdate = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `CertificadosAfiliados/${data.idItem}`,
        data,
        "PUT"
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(
            startAlerta(
              `Documentacion Actualizada correctamente`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(certificadoUpdated(data));
        } else {
          dispatch(startAlerta(response, "error", "Error"));
          console.log(response);
          throw new Error(response);
        }
      } else {
        console.log(response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, "error", "Error"));
      console.log("error en update certificado afiliado", error);
    }
  };
};
export const certificadoStageStartUpdate = ({ formValues }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      delete formValues.imagenCertificado;
      delete formValues.fechaCarga;
      delete formValues.fechaBaja;
      delete formValues.fechaModificacion;
      const response = await fetchConToken(
        `CertificadosAfiliadosStage/${formValues.idItem}`,
        formValues,
        "PUT"
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(
            startAlerta(
              `Documentacion Actualizada correctamente`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(certificadoUpdated(formValues));
        } else {
          dispatch(startAlerta(response, "error", "Error"));
          console.log(response);
          throw new Error(response);
        }
      } else {
        console.log(response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, "error", "Error"));
      console.log("error en update certificado afiliado", error);
    }
  };
};
export const certificadoInsertStart = (certificado) => {
  // console.log(certificado);
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `CertificadosAfiliados`,
        certificado,
        "POST"
      );
      //console.log('response endpoint',response);
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const certif = await response.json();
          // console.log('respuestaOk',certif);
          dispatch(certificadoInsertSuccess(certif));
          dispatch(
            startAlerta(
              `Certificado creado correctamente`,
              "success",
              "Comando Exitoso"
            )
          );
        } else {
          dispatch(certificadosInsertError(response));
          throw new Error(response);
        }
      } else {
        console.log("respuestaError", response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      //alertError(error);
      dispatch(certificadosInsertError(error));
      console.log("error en insert certificado", error);
    }
  };
};

export const certificadoStageInsertStart = (certificado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `CertificadosAfiliadosStage`,
        certificado,
        "POST"
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const certif = await response.json();
          dispatch(certificadoInsertSuccess(certif));
        } else {
          dispatch(certificadosInsertError(response));
          throw new Error(response);
        }
      } else {
        console.log("respuestaError", response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(certificadosInsertError(error));
      console.log("error en insert certificado", error);
    }
  };
};

export const fetchCertificados = (idAfiliado, fromDisca) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(certificadosTraerStart());
    const response = await fetchConToken(`CertificadosAfiliados/${idAfiliado}`);
    if (!response.ok) {
      dispatch(certificadosTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      // if (lista.length > 0) {
        dispatch(certificadosTraerSuccess(lista));
      // }
    }
    dispatch(finishSpinner());
    if(fromDisca)
      fromDisca.setShow(true);
  };
};
export const fetchCertificadosStage = (idAfiliado) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(certificadosTraerStart());
      const response = await fetchConToken(`CertificadosAfiliadosStage/${idAfiliado}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(certificadosTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      console.log( err );
      dispatch(finishSpinner());
      dispatch(startAlerta('Error al cargar los certificados', "warning", `¡Error!`));
    }
  };
};
export const evaluaCertificadoStageTitular = (idGrupoFamiliar) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    dispatch({
      type: types.certificadosCargadaTitularTraerCargadaStart,
    });
    const response = await fetchConToken(`Preafiliados/evaluaCertificadoTitular/${idGrupoFamiliar}`);
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log("respuesta cert stage titular", respuesta);
      if (response.status !== 200) throw respuesta.errores;
      dispatch({
        type: types.certificadosCargadaTitularTraerCargadaSuccess,
        payload: respuesta,
      });
    } else {
      console.log("error de get cert stage", response);
       throw new Error(response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch({
      type: types.certificadosCargadaTitularTraerCargadaError,
      payload: err.mensaje,
    });
    dispatch(startAlerta(err.mensaje, "warning", `¡Error!`))
    dispatch(finishSpinner());
  }
 
};

export const deleteFileCertificado = (idFileCertificado) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
        const result = await CertificadosService.deleteFileCertificado(idFileCertificado)
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch(fetchCertificados(getState().certificadosAfiliacion.items[0].idAfiliado))
        } else {
            throw result
        }

    } catch (error) {
        dispatch(finishSpinner());
        console.log("Error al eliminar el archivo", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}
export const deleteFileCertificadoDisca = (idFileCertificado, idCertificado) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const result = await CertificadosService.deleteFileCertificado(idFileCertificado)
    if (result.ok) {
        dispatch(imageCertificadoDelete({idFileCertificado, idCertificado}))
        dispatch(finishSpinner());
        dispatch(startAlerta(`Imagen Certificado Eliminada`,'success','Comando Exitoso'));
    } else {
        throw result
    }
  } catch (error) {
      dispatch(finishSpinner());
      if (error.mensaje) {
          dispatch(startAlerta(error.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}
export const deleteFileCertificadoStage = (idFileCertificado, idPreAfiliado) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
      const result = await CertificadosService.deleteFileCertificadoStage(idFileCertificado)
      if (result.ok) {
          dispatch(finishSpinner());
          dispatch(fetchCertificadosStage(idPreAfiliado));
      } else {
          throw result
      }

  } catch (error) {
      dispatch(finishSpinner());
      console.log("Error al eliminar el archivo", error)
      if (error.mensaje) {
          dispatch(startAlerta(error.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}

export const deleteCertificado = (idCertificado) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const result = await CertificadosService.deleteCertificado(idCertificado)
    if (result.ok) {
        dispatch(finishSpinner());
        dispatch(startAlerta("Certificado eliminado correctamente", "success"))

        dispatch(fetchCertificados(getState().afiliacion.afiliado.id_afiliado))
    } else {
        throw result
    }
  } catch (error) {
      dispatch(finishSpinner());
      console.log("Error al eliminar el certificado", error)
      if (error.mensaje) {
          dispatch(startAlerta(error.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}
export const deleteCertificadoDisca = (idCertificado) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const result = await CertificadosService.deleteCertificado(idCertificado);
    if (result.ok) {
      dispatch(certificadoDelete(idCertificado));
      dispatch(finishSpinner());
      dispatch(startAlerta("Certificado eliminado correctamente", "success"));
    } else {
      throw result
    }
  } catch (error) {
    dispatch(finishSpinner());
    console.log("Error al eliminar el certificado", error);
    if (error.mensaje) {
      dispatch(startAlerta(error.mensaje, "error"));
    } else {
      dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"));
    }
  }
}
export const deleteCertificadoStage = (idCertificado, idPreAfiliado) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
      const result = await CertificadosService.deleteCertificadoStage(idCertificado)
      if (result.ok) {
          dispatch(finishSpinner());
          dispatch(startAlerta("Certificado eliminado correctamente", "success"))

          dispatch(fetchCertificadosStage(idPreAfiliado));
      } else {
          throw result
      }

  } catch (error) {
      dispatch(finishSpinner());
      console.log("Error al eliminar el certificado", error)
      if (error.mensaje) {
          dispatch(startAlerta(error.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}
